// src/pages/system/ImageGuidelinePage.js (ตัวอย่าง path)
// ปรับ path/components ให้ตรงกับโครงโปรเจคของคุณได้เลยครับ

import React from "react";
import { Container, Row, Col, Card, Table, Badge } from "react-bootstrap";
// import "./ImageGuidelinePage.css"; // อย่าลืม import ถ้าคุณสร้างไฟล์ CSS แยก

function ImageGuidelinePage() {
  return (
    <div className="image-guideline-page">
      <Container>
        {/* Hero / Header */}
        <Row className="mb-4">
          <Col lg={{ span: 10, offset: 1 }}>
            <div className="mb-3">
              <Badge bg="primary" className="me-2">
                ChicChic
              </Badge>
              <Badge bg="secondary">Guideline</Badge>
            </div>
            <h1 className="image-guideline-title mb-2">
              Standard Image Guideline
            </h1>
            <p className="text-muted mb-1">
              เวอร์ชัน 1.0 · ใช้สำหรับภาพทั้งหมดในบทความบน chicchiclawtutor.com
            </p>
            <p className="text-muted">
              กำหนดมาตรฐานขนาดภาพ, สัดส่วน, และแนวทางการออกแบบ เพื่อให้หน้า
              บทความ, การ์ดบทความ และการแชร์ลงโซเชียลมีความสม่ำเสมอและโหลดไว
            </p>
          </Col>
        </Row>

        {/* Summary cards */}
        <Row className="g-4 mb-5">
          <Col md={4}>
            <Card className="guideline-card h-100">
              <Card.Body>
                <Card.Title className="fw-bold mb-2">
                  Cover Image
                </Card.Title>
                <Card.Subtitle className="text-muted mb-2">
                  ภาพหน้าปกบทความ
                </Card.Subtitle>
                <p className="mb-1">
                  <strong>ขนาด:</strong> 1200 × 628 px
                </p>
                <p className="mb-1">
                  <strong>อัตราส่วน:</strong> 1.91 : 1
                </p>
                <p className="small text-muted mb-0">
                  ใช้กับการ์ดบทความ, หน้าอ่านบทความ และภาพที่ใช้แชร์ลงโซเชียล
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="guideline-card h-100">
              <Card.Body>
                <Card.Title className="fw-bold mb-2">
                  Content Image
                </Card.Title>
                <Card.Subtitle className="text-muted mb-2">
                  ภาพในเนื้อหาบทความ
                </Card.Subtitle>
                <p className="mb-1">
                  <strong>ความกว้างสูงสุด:</strong> 940 px
                </p>
                <p className="mb-1">
                  <strong>ความสูง:</strong> height: auto (แนะนำ 788 px)
                </p>
                <p className="small text-muted mb-0">
                  รองรับทั้งภาพสี่เหลี่ยมจัตุรัส, แนวนอน, แนวตั้ง, Screenshot
                  และ Infographic
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="guideline-card h-100">
              <Card.Body>
                <Card.Title className="fw-bold mb-2">
                  Avatar & อื่น ๆ
                </Card.Title>
                <Card.Subtitle className="text-muted mb-2">
                  รูปโปรไฟล์และไอคอน
                </Card.Subtitle>
                <p className="mb-1">
                  <strong>Avatar ผู้เขียน:</strong> 96 × 96 px
                </p>
                <p className="mb-1">
                  <strong>ไฟล์ที่แนะนำ:</strong> PNG, JPEG
                </p>
                <p className="small text-muted mb-0">
                  ใช้รูปทรงกลม (circle) และควรบีบอัดให้ไฟล์เล็กแต่ยังคมชัด
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Section: Cover Image */}
        <Row className="mb-5">
          <Col lg={{ span: 10, offset: 1 }}>
            <h2 className="section-title mb-3" id="cover-image">
              1. Cover Image (ภาพหน้าปกบทความ)
            </h2>
            <p>
              ใช้สำหรับการแสดงในหน้า Card Grid, หน้าอ่านบทความ
              และการแชร์ลงโซเชียลผ่าน Open Graph (Facebook, LINE, X, LinkedIn)
            </p>

            <Card className="guideline-card mb-3">
              <Card.Body>
                <Row className="gy-3">
                  <Col md={6}>
                    <h5 className="fw-bold mb-2">รายละเอียดมาตรฐาน</h5>
                    <ul className="mb-0">
                      <li>
                        <strong>ขนาด:</strong> 1200 × 628 px
                      </li>
                      <li>
                        <strong>อัตราส่วน:</strong> 1.91 : 1 (แนวนอน)
                      </li>
                      <li>
                        <strong>ไฟล์ที่แนะนำ:</strong> JPEG (คุณภาพ 80–85%) หรือ
                        WebP
                      </li>
                      <li>
                        <strong>น้ำหนักไฟล์:</strong> ควรไม่เกิน 300 KB
                      </li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <h5 className="fw-bold mb-2">แนวทางการออกแบบ</h5>
                    <ul className="mb-0">
                      <li>จัดองค์ประกอบแบบ Landscape เท่านั้น</li>
                      <li>
                        เน้นจุดโฟกัสไว้บริเวณกึ่งกลางหรือด้านซ้ายของภาพ
                        (กันโดน UI ทับ)
                      </li>
                      <li>
                        ข้อความบนรูปไม่ควรเกิน ~25% ของพื้นที่
                        เพื่อให้อ่านง่ายทั้งบน Desktop และ Mobile
                      </li>
                      <li>หลีกเลี่ยงการใช้กรอบบาง ๆ รอบภาพ (border)</li>
                    </ul>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

    {/*         <Card className="guideline-card">
              <Card.Body>
                <h5 className="fw-bold mb-3">ตัวอย่างการตั้งค่า Open Graph</h5>
                <p className="small text-muted">
                  ตัวอย่างโค้ดที่ใช้ใน &lt;head&gt; ของหน้าแต่ละบทความ
                </p>
                <pre className="code-block">
                  <code>
{`<meta property="og:title" content="ชื่อบทความ" />
<meta property="og:description" content="คำอธิบายบทความ" />
<meta property="og:image" content="https://encraft.org/og/slug-ของบทความ.jpg" />
<meta property="og:image:width" content="1200" />
<meta property="og:image:height" content="628" />
<meta property="og:type" content="article" />`}
                  </code>
                </pre>
              </Card.Body>
            </Card> */}
          </Col>
        </Row>

        {/* Section: Content Image */}
        <Row className="mb-5">
          <Col lg={{ span: 10, offset: 1 }}>
            <h2 className="section-title mb-3" id="content-image">
              2. Content Image (ภาพในเนื้อหาบทความ)
            </h2>
            <p>
              ใช้ใน Block ประเภทภาพ เช่น ภาพประกอบ, Screenshot, Infographic
              ภายในเนื้อหาบทความ โดยเน้นให้คมชัดแต่ไม่หนักเว็บ
            </p>

            <Card className="guideline-card mb-3">
              <Card.Body>
                <Row className="gy-3">
                  <Col md={12}>
                    <h5 className="fw-bold mb-2">ขนาด & การแสดงผล</h5>
                    <ul className="mb-0">
                      <li>
                        <strong>ความกว้างสูงสุด (max-width):</strong> 940 px
                      </li>
                      <li>
                        <strong>width:</strong> 100% (responsive)
                      </li>
                      <li>
                        <strong>height:</strong> auto
                      </li>
                      <li>รองรับทุกอัตราส่วนของรูปภาพ</li>
                    </ul>
                  </Col>
 {/*                  <Col md={6}>
                    <h5 className="fw-bold mb-2">ตัวอย่าง CSS ที่ใช้ใน Encraft</h5>
                    <pre className="code-block">
                      <code>
{`.article-content img {
  max-width: 940px;
  width: 100%;
  height: auto;
  display: block;
  margin: 24px auto;
  border-radius: 8px;
}`}
                      </code>
                    </pre>
                  </Col> */}
                </Row>
              </Card.Body>
            </Card>

            <Card className="guideline-card">
              <Card.Body>
                <h5 className="fw-bold mb-2">แนวทางการใช้งาน</h5>
                <ul className="mb-0">
                  <li>ใช้ภาพที่มีความละเอียดเพียงพอเพื่อไม่ให้แตกบนจอใหญ่</li>
                  <li>บีบอัดไฟล์ก่อนอัปโหลดเพื่อช่วยเรื่องความเร็วในการโหลด</li>
                  <li>หลีกเลี่ยงการใส่ข้อความสำคัญไว้ชิดขอบรูปมากเกินไป</li>
                  <li>
                    หากเป็นภาพแนวตั้งยาว ควรพิจารณาแบ่งเป็นหลายภาพย่อยเพื่อความอ่านง่าย
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Section: Avatar / File type table */}
        <Row className="mb-5">
          <Col lg={{ span: 10, offset: 1 }}>
            <h2 className="section-title mb-3" id="avatar">
              3. Avatar & ไอคอนอื่น ๆ
            </h2>

            <Card className="guideline-card mb-3">
              <Card.Body>
                <Row className="gy-3">
                  <Col md={6}>
                    <h5 className="fw-bold mb-2">Avatar ผู้เขียน</h5>
                    <ul className="mb-0">
                      <li>
                        <strong>ขนาดที่ใช้แสดงผลหลัก:</strong> 96 × 96 px
                      </li>
                      <li>รูปทรงกลม (ใช้ border-radius: 50%)</li>
                      <li>ใช้ภาพใบหน้าชัดเจน หรือโลโก้ตัวอักษรแทน</li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <h5 className="fw-bold mb-2">ไฟล์รูปแบบที่แนะนำ</h5>
                    <Table size="sm" borderless className="mb-0">
                      <tbody>
                        {/* <tr>
                          <td className="fw-bold">WebP</td>
                          <td>คุณภาพดี + ขนาดไฟล์เล็ก (แนะนำ)</td>
                        </tr> */}
                        <tr>
                          <td className="fw-bold">JPEG</td>
                          <td>เหมาะกับภาพถ่าย, ปกบทความ</td>
                        </tr>
                        <tr>
                          <td className="fw-bold">PNG</td>
                          <td>ใช้เมื่อจำเป็นต้องมีพื้นหลังโปร่งใส</td>
                        </tr>
                        <tr>
                          <td className="fw-bold text-muted">GIF</td>
                          <td className="text-muted">
                            ไม่แนะนำ (ขนาดใหญ่ / โหลดช้า)
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Section: Upload / Dev Note */}
        <Row className="mb-5">
          <Col lg={{ span: 10, offset: 1 }}>
            <h2 className="section-title mb-3" id="upload">
              4. แนวทางการอัปโหลด & ฝั่ง Dev
            </h2>

            <Card className="guideline-card">
              <Card.Body>
                <Row className="gy-3">
                  <Col md={12}>
                    <h5 className="fw-bold mb-2">สำหรับผู้เขียน / ทีมคอนเทนต์</h5>
                    <ul className="mb-0">
                      <li>
                        เตรียม Cover Image ขนาด 1200 × 628 px
                        ก่อนอัปโหลดทุกครั้ง
                      </li>
                      <li>
                        สำหรับภาพในเนื้อหา ให้ใช้ความกว้างอย่างน้อย 1200 px
                        เพื่อรองรับจอใหญ่
                      </li>
                      {/* <li>บีบอัดภาพด้วยเครื่องมือเช่น TinyJPG / Squoosh</li> */}
                    </ul>
                  </Col>
                  {/* <Col md={6}>
                    <h5 className="fw-bold mb-2">สำหรับนักพัฒนา (Dev)</h5>
                    <ul className="mb-0">
                      <li>
                        พิจารณาใช้ Cloud Functions สำหรับ resize
                        และทำ thumbnail อัตโนมัติ
                      </li>
                      <li>
                        เก็บ metadata ของรูปใน Firestore เช่น width, height,
                        type (cover/content)
                      </li>
                      <li>
                        ใช้ loading="lazy" กับภาพในบทความเพื่อลดการโหลดครั้งแรก
                      </li>
                    </ul>
                  </Col> */}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Footer note */}
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            <p className="text-muted small mb-0 text-end">
              อัปเดตล่าสุด: 2026 · ChicChic Image Guideline v1.0
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ImageGuidelinePage;
